import { inject, Injectable } from '@angular/core';
import { AppConfigService } from '../config.service';
import { IPaymentGateway } from './payment-gateway.interface';
import { AdyenPaymentGateway } from './adyen-payment-gateway.service';
import { StripePaymentGateway } from './stripe-payment-gateway.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentGatewayFactory {
  private readonly appConfigService = inject(AppConfigService);
  private readonly adyenGateway = inject(AdyenPaymentGateway);
  private readonly stripeGateway = inject(StripePaymentGateway);

  /**
   * Get the appropriate payment gateway based on configuration
   * Defaults to Adyen if no paymentProvider is specified
   */
  getPaymentGateway(): IPaymentGateway {
    const paymentProvider = this.appConfigService.currentConfig().paymentProvider;
    
    switch (paymentProvider) {
      case 'stripe':
        return this.stripeGateway;
      case 'adyen':
        return this.adyenGateway;
      default:
        return this.stripeGateway; //default to Stripe
    }
  }
}

